import { FlexContainer, ReemaThemeV2 } from '@act/storybook';
import { GoalsPanelContent } from '../GoalsPanelContent';
import { Box } from '@mui/material';
import { LoadingStatus } from 'redux/types/sharedTypes';
import { UserDto } from '@act/shared/data-transfer-objects';
import { Goal } from 'stories/containers/GoalsTracking/types';

interface Props {
  goals: Goal[];
  goalsLoadingStatus: LoadingStatus;
  selectedMember: UserDto;
  onGoalClick: (goal: Goal) => void;
  setOpenAddNeed: (open: boolean) => void;
}

export const GoalsContent = ({
  goals,
  goalsLoadingStatus,
  selectedMember,
  onGoalClick,
  setOpenAddNeed,
}: Props) => {
  return (
    <FlexContainer
      borderRadius="lessRounded"
      direction="column"
      gap={4}
      padding={4}
      width="100%"
      height={'80%'}
      backgroundColor={ReemaThemeV2.LIGHT_MODE.palette.greyShades[100]}
      border={`1px solid ${ReemaThemeV2.LIGHT_MODE.palette.greyShades[250]}`}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          overflowY: 'auto',
          flex: 1,
        }}
      >
        <GoalsPanelContent
          selectedMember={selectedMember}
          goals={goals}
          goalsLoadingStatus={goalsLoadingStatus}
          onGoalClick={onGoalClick}
          onAddNeedClick={() => setOpenAddNeed(true)}
        />
      </Box>
    </FlexContainer>
  );
};
